import React from "react";
import "./BottomBar.css";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import Slider from "react-slick";

const specifiqueTitle = "Specifique Norge AS © " + new Date().getFullYear();
const image1 = require("./static/Ombudet_logo.png");
const image2 = require("./static/medietilsynet-logo.png");
const image3 = require("./static/Specifique-logo-hvit.png");
const images = [image1, image2, image3];

const lenker = [
  "https://bfk.no/tjenester/skole-og-opplaring/ombudet-for-barn-og-unge/",
  "https://www.medietilsynet.no/",
  "http://specifique.no/",
];

var settings = {
  dots: false,
  arrows: false,
  infinite: true,
  useCSS: true,
  accessibility: true,
  swipeToSlide: true,
  draggable: true,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  touchMove: true,
};

const BottomBar = ({ fixed }) => (
  <div
    className={"HomePage-bottomBar" + (fixed ? " BottomBar-fixed-bottom" : "")}
  >
    <div className="LogosRow">
      {images.map((image, index) => (
        <a
          key={index + "bottombar-images"}
          href={lenker[index]}
          target="_blank"
        >
          <img alt="" src={image} style={{ height: "auto", padding: 10 }} />
        </a>
      ))}
    </div>
    <div className="MySliderContainer">
      <div className="SlickWrapper">
        <Slider {...settings}>
          {images.map((image, index) => (
            <div
              key={index}
              style={{
                display: "flex",
                height: "100px",
                flex: 1,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <a href={lenker[index]} target="_blank">
                <img data-index={index} key={index} alt="" src={image} />
              </a>
            </div>
          ))}
        </Slider>
      </div>
    </div>
    <div className="HomePage-specifique-title">{specifiqueTitle}</div>
  </div>
);

export default BottomBar;



// WEBPACK FOOTER //
// ./src/components/BottomBar.js